export const SUPPORT_EMAIL = 'feedback@pixee.ai'

// Authentik flow that presents a local username/password form with no IdP sources (added in
// ISS-7776). It lets an admin sign in as a local Authentik user to administer IdP/federation even
// when the default flow auto-redirects to the upstream IdP. Relative to the deployment host.
export const AUTHENTIK_ADMIN_LOGIN_PATH = '/authentik/if/flow/direct-authentication-flow/'
